module.exports = __webpack_public_path__ + "img/9788901166483.3a38e869.jpg";